import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { FiArrowLeft } from 'react-icons/fi';

function BackButton({ to = -1 }) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY) {
        setVisible(false); // scrolling down → hide
      } else {
        setVisible(true); // scrolling up → show
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <IconButton
      onClick={() => navigate(to)}
      sx={{
        position: 'fixed',
        top: '16px',
        left: '16px',
        background: 'linear-gradient(135deg, #00bcd4, #007bff)',
        color: '#fff',
        zIndex: 1000,
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.3s ease',
        '&:hover': {
          transform: 'scale(1.1)',
          background: 'linear-gradient(135deg, #0097a7, #0056b3)',
        },
        borderRadius: '12px',
        padding: '8px 12px',
      }}
    >
      <FiArrowLeft />
    </IconButton>
  );
}

export default BackButton;
